// const the_vendor_leadtime = '';
// const the_vendor_leadtime_apply = '';
// const all_labels = '';
// const the_vendor_leadtime_applyArray = '';

function getLeadTimes() {

    //GET VARS
    the_vendor_leadtime = document.querySelector('.product-vendor').dataset.vendorLeadTime;
    the_vendor_leadtime_apply = document.querySelector('.product-vendor').dataset.variantsApplyLeadTimes.toLowerCase();
    all_labels = document.querySelectorAll('.options-selection__select label');

    //SPLIT APPLY ARRAY TO COMPARE
    the_vendor_leadtime_applyArray = the_vendor_leadtime_apply.split(', ');

    var all_labels_array = [];
    //CREATE LABEL ARRAY
    all_labels.forEach((single_label) => {
        var option_name = single_label.dataset.variantOptionName;
        if (option_name != null || option_name != undefined) {
            all_labels_array.push(option_name.toLowerCase());
        }
    });

    //ALL SELECTS
    const form_all_selects = document.querySelectorAll('.options-selection__input-select');

    //LOOP SELECTS
    form_all_selects.forEach((single_select) => {
        var og_value = single_select[0].value;
        //GET INIT LEAD TIMES
        getLeadData(single_select, og_value);
        //IF SELECT CHANGES
        single_select.addEventListener("change", function (e) {
            getLeadData(single_select, og_value);
        });
    });
}

//GETS DATA TO BUILD OR REMOVE LEAD TAG
function getLeadData(single_select, og_value) {
    //IF OPTION LABEL DATA
    if (single_select.dataset.optionLabel != null) {
        var label_val = single_select.dataset.optionLabel.toLowerCase();
    } else {
        var label_val = single_select.dataset.optionName.toLowerCase();
    }
    //TRUE OR FALSE IF APPLY MATCHES OR PARTLY MATCHES
    var apply_lead = false;
    var stringIncludesLabel = the_vendor_leadtime_applyArray.some(label => label_val.includes(label));
    if (the_vendor_leadtime_applyArray.includes(label_val) || stringIncludesLabel == true) {
        apply_lead = true;
    }
    //LEAD TIMES
    if (the_vendor_leadtime != '') {
        var lead_time_p = single_select.parentNode.parentNode.querySelector('.lead-time-msg');
        if (single_select.value != og_value && apply_lead == true) {
            if (lead_time_p == null) {
                leadTimeShow(single_select, the_vendor_leadtime);
            }
        } else {
            if (lead_time_p != null) {
                lead_time_p.remove();
            }
        }
    }
}

//SHOW LEAD TIMES
function leadTimeShow(single_select, the_vendor_leadtime) {
    let lead_time = document.createElement('p');
    lead_time.className = 'lead-time-msg mt-10 mb-0 small red-txt';
    lead_time.textContent = '* '+the_vendor_leadtime;

    single_select.parentNode.after(lead_time);
}